import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@ui-kitten/components';
import dayjs from 'dayjs';

import Button from '../../../../Components/Button';
import { textCategory } from '../../../../Components/Reservation/constants';
import ReservationOverview from '../../../../Components/Reservation/Overview';
import ResponsiveText from '../../../../Components/ResponsiveText';
import constants from '../../../../Config/constants';
import { TableDetails } from '../../../../RTK/api/reservations/types';
import themeStyle from '../../../../Theme/styles';

import cardStyles from './styles';

type Props = TableDetails & {
  onPress: (ts: string) => void; // ts is constants.TIME_ONLY_DISPLAY_CAPITAL_FORMAT
};

const ReservationCardTable = ({
  experiences,
  is_communal,
  maximum,
  minimum,
  name,
  time_slots,
  onPress,
}: Props) => {
  const theme = useTheme();
  const pickSlots = useMemo(() => {
    const formattedTimeSlots = time_slots.map((ts) =>
      dayjs(ts, constants.DBTIME_FORMAT).format(
        constants.TIME_ONLY_DISPLAY_CAPITAL_FORMAT,
      ),
    );
    if (formattedTimeSlots.length > 3) {
      return formattedTimeSlots.slice(0, 3);
    }
    return formattedTimeSlots;
  }, [time_slots]);

  return (
    <View
      style={[
        cardStyles.listItemWrapper,
        { borderColor: theme['color-info-500'] },
      ]}
    >
      <View
        style={
          is_communal
            ? styles.marginToMatchEventCommunal
            : styles.marginToMatchEvent
        }
      >
        <ResponsiveText
          category={textCategory.BODY}
          numberOfLines={1}
          style={[themeStyle.bold, themeStyle.spacingBottomSmall]}
        >
          Book your {is_communal ? 'seat' : 'table'} - {name}
        </ResponsiveText>
        <ReservationOverview
          contentContainerStyle={themeStyle.spacingBottomXXSmall}
          iconSize={15}
          textCategory={textCategory.SMALL_BODY}
          tableData={{
            is_communal,
            experiences,
            maximum,
            minimum,
          }}
        />
      </View>
      {/* Time slots pill */}
      <View style={[themeStyle.flexDirectionRow, styles.marginOffsetH]}>
        {pickSlots.map((slot) => (
          <Button
            key={slot}
            status="info"
            style={[
              cardStyles.btn,
              themeStyle.flex1,
              themeStyle.spacingLeftSmall,
              themeStyle.spacingRightSmall,
            ]}
            onPress={() => onPress?.(slot)}
          >
            {() => (
              <ResponsiveText
                appearance="alternative"
                category={textCategory.BODY}
                numberOfLines={1}
                adjustsFontSizeToFit
              >
                {slot}
              </ResponsiveText>
            )}
          </Button>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  marginToMatchEvent: {
    marginBottom: 33,
  },
  marginToMatchEventCommunal: {
    marginBottom: 15,
  },
  marginOffsetH: {
    marginHorizontal: -5,
  },
});

export default ReservationCardTable;
